"use strict";
/**
 * @fileoverview Request body interface for searching orders
 * Defines the structure for order search requests
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSort = exports.AmountBasis = exports.DeliverySettlementStatus = exports.PaymentStatus = void 0;
const PaymentStatus_js_1 = require("../../CommonTypes/PaymentStatus.js");
Object.defineProperty(exports, "PaymentStatus", { enumerable: true, get: function () { return PaymentStatus_js_1.PaymentStatus; } });
const DeliverySettlementStatus_js_1 = require("../../CommonTypes/DeliverySettlementStatus.js");
Object.defineProperty(exports, "DeliverySettlementStatus", { enumerable: true, get: function () { return DeliverySettlementStatus_js_1.DeliverySettlementStatus; } });
/**
 * Controls whether delivery price is included in the total used for
 * payment-status and outstanding-amount calculations.
 *
 * include_delivery - delivery price is added to the order total before
 *                    comparing against paidAmount (default)
 * exclude_delivery - delivery price is excluded; only article totals count
 */
var AmountBasis;
(function (AmountBasis) {
    AmountBasis["INCLUDE_DELIVERY"] = "include_delivery";
    AmountBasis["EXCLUDE_DELIVERY"] = "exclude_delivery";
})(AmountBasis || (exports.AmountBasis = AmountBasis = {}));
/**
 * Order sort enumeration
 */
var OrderSort;
(function (OrderSort) {
    OrderSort[OrderSort["NEWEST"] = -1] = "NEWEST";
    OrderSort[OrderSort["OLDEST"] = 1] = "OLDEST";
    OrderSort["DEADLINE_SOONEST"] = "deadline_soonest";
    OrderSort["DEADLINE_LATEST"] = "deadline_latest";
    /** Smart sort: ranks orders by state urgency, deadline, total amount, and order date. */
    OrderSort["SMART"] = "smart";
})(OrderSort || (exports.OrderSort = OrderSort = {}));
